import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function WebDevelopment() {

useEffect(() => {
AOS.init({ duration: 1000, once: true });
}, []);


    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Web Development</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Web Development Services Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up" >Our Web Development Services</h2>
                        <p className="section-description">
                        We build powerful, scalable websites using modern back-end technologies such as Node.js, Express, Laravel, ASP.NET, and Django.                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-code"></i>
                            </div>
                            <h3>Custom Web Development</h3>
                            <p>Every solution is designed with performance, security, and a smooth user experience in mind, ensuring your website is both reliable and future-ready..</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-shopping-cart"></i>
                            </div>
                            <h3>E-Commerce Solutions</h3>
                            <p>Our team specializes in creating tailored platforms, whether a fully custom solution built from the ground up, a robust e-commerce platform with integrated payment systems and inventory control.</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-tablet-alt"></i>
                            </div>
                            <h3>Responsive Web Design</h3>
                            <p>Our process is transparent and methodical, guiding each project from planning to ongoing optimization: Websites that adapt seamlessly to all devices, ensuring optimal user experience across platforms.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Development Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header" data-aos="fade-up">
                        <h2>Process of Creating a Website</h2>
                        <p className="section-description">
                            From strategy to deployment, our step-by-step process ensures quality, clarity, and success at every stage of your web project.
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Define Goals & Objectives</h3>
                                <p>
                                    Determine the purpose of your website, identify your target audience, and outline key features and functionality requirements.
                                    </p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>Plan & Research</h3>
                                <p>Conduct thorough research on audience and competitors, create a sitemap for structure, and plan content strategy.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="400">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Choose Development Platform</h3>
                                <p>Select the best technology stack, whether that’s a content management system or fully custom development</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="450">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>Design User Interface</h3>
                                <p>Design intuitive layouts with a focus on responsive design, accessibility, and a great user experience.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Development & Coding</h3>
                                <p>Build out functionality through front-end and back-end coding, database integration, and CMS setup.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Content Creation</h3>
                                <p>Produce well-written, SEO-focused content to strengthen brand messaging and improve visibility.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="100">
                            <div className="step-number">7</div>
                            <div className="step-content">
                                <h3>Testing & Debugging</h3>
                                <p>Test extensively to ensure your site is fast, secure, and bug-free across all browsers and devices.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="100">
                            <div className="step-number">8</div>
                            <div className="step-content">
                                <h3>Launch</h3>
                                <p>Launch with secure hosting, domain setup, SSL certification, and backups in place..</p>
                            </div>
                        </div>
                        
                        <div className="process-step" data-aos="fade-left" data-aos-delay="100">
                            <div className="step-number">9</div>
                            <div className="step-content">
                                <h3>Maintenance & Updates</h3>
                                <p>Provide regular updates, content changes, and technical maintenance to keep your site running at its best.</p>
                            </div>
                        </div>
                        
                        <div className="process-step" data-aos="fade-left" data-aos-delay="100">
                            <div className="step-number">10</div>
                            <div className="step-content">
                                <h3>Analytics & Optimization</h3>
                                <p>Continuously track performance and user engagement with analytics to refine and optimize the website over time.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Key Features Section */}
            <section className="why-choose-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Key Features of Our Websites</h2>
                    </div>

                    <div className="features-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3>Responsive Design</h3>
                            <p>Fully responsive layouts that adjust flawlessly to desktops, tablets, and mobile devices..</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-user-friends"></i>
                            </div>
                            <h3>User-Friendly Interface</h3>
                            <p>A user-friendly structure with simple navigation to help visitors find what they need quickly.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-paint-brush"></i>
                            </div>
                            <h3>Compelling Visual Design</h3>
                            <p>Aesthetic designs that reflect your brand identity with cohesive colors, fonts, and visuals.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-file-alt"></i>
                            </div>
                            <h3>Engaging Content</h3>
                            <p>Engaging, valuable content that builds trust and encourages users to take action.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-comments"></i>
                            </div>
                            <h3>Interactive Elements</h3>
                            <p>Interactive features like forms, polls, social sharing, and feedback tools to enhance engagement.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-bolt"></i>
                            </div>
                            <h3>Fast Load Times</h3>
                            <p>Optimized performance with fast load times, efficient code, and smart caching for a seamless browsing experience.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Backend Technology Section (Additional) */}


            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Build Your Web Application?</h2>
                        <p>Let's create a powerful, scalable solution that drives your business forward.</p>
                        <a href="/contact" className="cta-button">Get a Free Consultation</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default WebDevelopment;
